export default __webpack_public_path__ + "static/media/proatividade.4c681c3d.png";